// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Menu Standalone Component */
.mobile-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--scrim);
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.mobile-menu-backdrop.visible {
  opacity: 1;
}

.mobile-menu {
  background: var(--color-white);
  width: 100vw;
  height: 100vh;
  transform: translateY(-100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
  position: relative;
}

.mobile-menu.open {
  transform: translateY(0);
}

/* Header */
.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  min-height: 64px;
  border-bottom: 1px solid var(--color-light-gray);
  background-color: var(--color-white);
  position: sticky;
  top: 0;
  z-index: 10;
}

.mobile-menu-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--color-black);
  flex: 1;
}

/* Navigation */
.mobile-menu-nav {
  flex: 1;
  overflow-y: auto;
  padding: 16px 0;
  background-color: var(--color-white);
}

.mobile-menu-section {
  margin-bottom: 24px;
}

.mobile-menu-section:last-child {
  margin-bottom: 0;
}

.mobile-menu-section-header {
  padding: 0 24px 8px 24px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mobile-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu-item {
  margin: 0;
}

.mobile-menu-link {
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 16px 24px;
  text-align: left;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;
  border-radius: 0;
}

.mobile-menu-link:hover {
  background-color: var(--color-light-gray);
}

.mobile-menu-link.active {
  background-color: var(--color-light-green);
  font-weight: 600;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .mobile-menu-header {
    padding: 20px 24px;
    min-height: 64px;
  }
  
  .mobile-menu-section-header {
    padding: 0 20px 8px 20px;
  }
  
  .mobile-menu-link {
    padding: 14px 20px;
  }
  
  .mobile-menu-link.active {
    padding-left: 16px;
  }
}

/* Handle safe areas for devices with notches */
@supports (padding: max(0px)) {
  .mobile-menu {
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
}

/* Smooth scrolling for content */
.mobile-menu-nav {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* Focus styles for accessibility */
.mobile-menu-link:focus {
  outline: 2px solid var(--color-primary-green);
  outline-offset: -2px;
} `, "",{"version":3,"sources":["webpack://./src/components/MobileMenu/MobileMenu.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,uDAAuD;EACvD,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,OAAO;AACT;;AAEA,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,0CAA0C;IAC1C,gDAAgD;EAClD;AACF;;AAEA,iCAAiC;AACjC;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,6CAA6C;EAC7C,oBAAoB;AACtB","sourcesContent":["/* Mobile Menu Standalone Component */\n.mobile-menu-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--scrim);\n  z-index: 1000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.mobile-menu-backdrop.visible {\n  opacity: 1;\n}\n\n.mobile-menu {\n  background: var(--color-white);\n  width: 100vw;\n  height: 100vh;\n  transform: translateY(-100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-lg);\n  position: relative;\n}\n\n.mobile-menu.open {\n  transform: translateY(0);\n}\n\n/* Header */\n.mobile-menu-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  min-height: 64px;\n  border-bottom: 1px solid var(--color-light-gray);\n  background-color: var(--color-white);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.mobile-menu-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-black);\n  flex: 1;\n}\n\n/* Navigation */\n.mobile-menu-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 0;\n  background-color: var(--color-white);\n}\n\n.mobile-menu-section {\n  margin-bottom: 24px;\n}\n\n.mobile-menu-section:last-child {\n  margin-bottom: 0;\n}\n\n.mobile-menu-section-header {\n  padding: 0 24px 8px 24px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.mobile-menu-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mobile-menu-item {\n  margin: 0;\n}\n\n.mobile-menu-link {\n  width: 100%;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 16px 24px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s ease;\n  border-radius: 0;\n}\n\n.mobile-menu-link:hover {\n  background-color: var(--color-light-gray);\n}\n\n.mobile-menu-link.active {\n  background-color: var(--color-light-green);\n  font-weight: 600;\n}\n\n/* Mobile optimizations */\n@media (max-width: 768px) {\n  .mobile-menu-header {\n    padding: 20px 24px;\n    min-height: 64px;\n  }\n  \n  .mobile-menu-section-header {\n    padding: 0 20px 8px 20px;\n  }\n  \n  .mobile-menu-link {\n    padding: 14px 20px;\n  }\n  \n  .mobile-menu-link.active {\n    padding-left: 16px;\n  }\n}\n\n/* Handle safe areas for devices with notches */\n@supports (padding: max(0px)) {\n  .mobile-menu {\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n}\n\n/* Smooth scrolling for content */\n.mobile-menu-nav {\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n}\n\n/* Focus styles for accessibility */\n.mobile-menu-link:focus {\n  outline: 2px solid var(--color-primary-green);\n  outline-offset: -2px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
